/*@flow*/
import React from 'react';
import ChartContainer from '../ChartContainer';
import { type CartoResponse } from 'lib/getCartoMap';
import VegaLiteFlex from 'comps/App/VegaLite/Flex';

const BIN_TMPL = query => `
  WITH A0 as (
    ${query}
  ),
  A1 as (
    SELECT complaint_type, month as created_date, count(*) OVER (PARTITION BY month, complaint_type)
      FROM A0
  )
  SELECT distinct count, complaint_type, created_date
  FROM A1
`;

const VEGA_SPEC = {
  $schema: 'https://vega.github.io/schema/vega-lite/v3.json',
  autosize: { type: 'fit', resize: false, contains: 'padding' },
  padding: { left: 10, top: 10, right: 10, bottom: 10 },

  config: {
    bar: {
      continuousBandSize: 10,
    },
  },

  layer: [
    {
      mark: { type: 'bar' },

      selection: {
        itemSelection: {
          type: 'single',
          fields: ['complaint_type'],
        },
        gridSelection: {
          type: 'interval',
          bind: 'scales',
          encodings: ['x', 'y'],
        },
      },

      encoding: {
        x: {
          field: 'created_date',
          type: 'temporal',
          timeUnit: 'yearmonth',
          axis: {
            format: '%b %e, %Y',
            title: '',
            timeUnit: 'week',
          },
        },
        y: {
          field: 'count',
          type: 'quantitative',
          aggregate: 'sum',
          axis: {
            title: 'Count',
            format: ',.0~f',
          },
        },
        color: {
          condition: {
            selection: 'itemSelection',
            field: 'complaint_type',
            type: 'nominal',
            axis: { title: null },
            legend: null,
            scale: {
              scheme: 'tableau20',
            },
          },
          value: 'grey',
        },
        tooltip: [
          {
            field: 'complaint_type',
            type: 'nominal',
            axis: { title: 'Complaint Type' },
          },
          {
            field: 'count',
            type: 'quantitative',
            axis: { title: 'Count' },
          },
        ],
      },
    },
  ],
};

export default (props: {
  onSelect: Function,
  analysisId: ?string,
  mapConfig: ?CartoResponse,
}) => {
  const { onSelect, mapConfig, analysisId } = props;

  return (
    <ChartContainer
      mapConfig={mapConfig}
      queryTransform={BIN_TMPL}
      analysisId={analysisId}
    >
      {({ data }) => {
        return (
          <VegaLiteFlex
            signals={{ onSignalItemSelection_tuple: onSelect }}
            data={{
              values: data,
            }}
            spec={VEGA_SPEC}
          />
        );
      }}
    </ChartContainer>
  );
};
